import { Component, Inject, OnInit } from '@angular/core';
import { DocumentsDataModel } from '../../models/documents-data.model';
import { slideInOut } from '../../utils/animations/slides.animation';
import {
  NotificationProviderService,
  NotificationProviderTypeEnum
} from '../../external-interfaces/notification-provider.service';
import { CommonInfoService } from '../../cart-process/common-info.service';
import SlotService from '../../cart-process/slot.service';

@Component({
  selector: 'documents-component',
  templateUrl: './documents.component.html',
  animations: [slideInOut]
})
export class DocumentsComponent implements OnInit {

  public headerText: string;
  public documentsData: DocumentsDataModel[] = [];
  public isListVisible: boolean = false;

  constructor(
    private commonInfo: CommonInfoService,
    private slotService: SlotService,
    private notificationProvider: NotificationProviderService,
    @Inject('Endpoint') private endpoint: any
  ) {
  }

  ngOnInit() {
    this.endpoint('newCart.documents')
      .run()
      .then((response: DocumentsDataModel[]) => {
        this.prepareData(response);
      })
      .catch((_error: any) => {
        console.error(_error);
      });

    this.notificationProvider.subscribe(NotificationProviderTypeEnum.COMMON_INFO, (commonInfo: CommonInfoService) => {
      if (commonInfo) {
        this.update();
      }
    });
  }

  private prepareData(documentsData: DocumentsDataModel[]) {
    documentsData.forEach((item: DocumentsDataModel) => this.documentsData.push(new DocumentsDataModel(item)));
  }

  private update() {
    if (this.commonInfo.isRetentionOffer && !this.slotService.hasAtLeastOneDeviceInCart()) {
      this.headerText = 'Poniższe dokumenty są do wglądu. Nie musisz ich drukować.';
    } else if (this.commonInfo.isOtherSalesOffer) {
      this.headerText = 'Poniższe dokumenty są do wglądu.';
    } else {
      this.headerText = 'Poniższe dokumenty są do wglądu. Nie musisz ich drukować. Komplet dokumentów dostaniesz od nas przy podpisywaniu umowy.';
    }
  }
}
